<template>
    <div>
        <!-- Footer -->
        <div class="footer mt-3" :class="isMobile ? 'footer-sm' : 'footer-lg'" v-if="$route.path !== '/maung-fb' && $route.path !== '/body-fb' && $route.path !== '/correct-score-fb' && $route.path !== '/1x2-fb'">
            <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
            <div class="align-items-center justify-content-lg-between">
                <div class="col-lg-12 text-center">
                    <ul class="nav nav-footer justify-content-between">
                        <li
                            class="nav-item"
                            @click="$router.push('/home')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img  class="mx-auto" :src="linkIsActive('/home') ? 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/mdl-new-version/icons/home1.png' : 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/mdl-new-version/icons/home.png'" style="width: auto; height: 1.5rem;" alt="">
                                <div :class="linkIsActive('/home') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #ccc;">
                                    {{$t('footer.home')}}
                                </div>
                            </div>
                        </li>
                        
                        <!-- <li
                            class="nav-item"
                            @click="openModal()"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="/build/assets/img/icons/Download.png" style="width: 18px; height: 18px" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #a486ea;">
                                    {{
                                        $store.state.language === "en"
                                            ? "Download"
                                            : "ဒေါင်းလုတ်"
                                    }}
                                </div>
                            </div>
                        </li> -->
                        <!-- :class="linkIsActive('/deposit') ? 'active' : ''" -->
 
                        <!-- <li
                            class="nav-item"
                            @click="$router.push('/history')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" :src="linkIsActive('/history') ? 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/salmon/icons/trasnsfer.png-1.png' : 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/salmon/icons/trasnsfer.png'" style="width: auto; height: 1.5rem;" alt="">
                                <div :class="linkIsActive('/history') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #ccc;">
                                    {{$t('setting.transaction')}}
                                </div>
                            </div>
                        </li> -->
                        <!-- <li
                            class="nav-item"
                        >
                            <a href="#">
                                <div class="d-flex flex-column banking-icons">
                                    <img class="mx-auto" src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/telegram%20(2).png" style="width: auto; height: 1.5rem;" alt="">
                                    <div :class="linkIsActive('/home') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #ccc;">
                                        {{$t('setting.customer_service')}}
                                    </div>
                                </div>
                            </a>
                        </li> -->
                        <li
                            class="nav-item"
                        >
                            <div class="d-flex flex-column banking-icons" id="popover-target-1">
                                <img class="mx-auto" :src="linkIsActive('/deposit') ? 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/mdl-new-version/icons/wallet1.png' : 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/mdl-new-version/icons/wallet.png'" style="width: auto; height: 1.5rem;" alt="">
                                <div :class="linkIsActive('/deposit') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #ccc;">
                                    {{$t('home.wallet')}}
                                </div>
                            </div>
                            <b-popover target="popover-target-1" placement="top" ref="popover">
                                <template #title>{{ $t('home.please_choose_one') }}</template>
                                <div class="d-flex justify-content-between">
                                    <button
                                        type="button"
                                        style="width: 45%;"
                                        class="btn btn-success text-dark"
                                        @click="$router.push('/deposit'), onClose()"
                                    >
                                        {{ $t('setting.deposit') }}
                                    </button>
                                    <button
                                        type="button"
                                        style="width: 45%;"
                                        class="btn btn-dark"
                                        @click="$router.push('/withdraw'), onClose()"
                                    >
                                        {{ $t('setting.withdraw') }}
                                    </button>
                                </div>
                            </b-popover>
                        </li>

                        <li
                            class="nav-item"
                        >
                        <a
                            href="viber://contact?number=%2B959968968600"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" :src="linkIsActive('/live-chat') ? 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/mdl-new-version/icons/customer%20service1.png' : 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/mdl-new-version/icons/customer%20service.png'" style="width: auto; height: 1.5rem;" alt="">
                                <div :class="linkIsActive('/live-chat') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #ccc;">
                                        {{$t('home.live_chat')}}
                                </div>
                            </div>
                        </a>
                        </li>

                        <li
                            class="nav-item"
                            @click="$router.push('/setting')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" :src="linkIsActive('/setting') ? 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/mdl-new-version/icons/account1.png' : 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/mdl-new-version/icons/account.png'" style="width: auto; height: 1.5rem;" alt="">
                                <div :class="linkIsActive('/setting') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #ccc;">
                                    {{$t('footer.profile')}}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      is_live: false,
      isMobile: false,
    };
  },
  methods: {
    onClose() {
        this.$refs.popover.$emit('close')
    },
    closeModal() {
      $('#download-modal').modal('hide');
    },
    openModal() {
      $('#download-modal').modal('show');
    },
    /* example link = '/settings' */
    linkIsActive(link) {
      console.log(this.$route.path === link);
      if (this.$route.path === link) return true;
      return false;
    },
    async fetchFootballLive() {
      try {
        const res = await axios.get('/football-lives');
        this.is_live = res.data.data[0].is_live;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    // this.fetchFootballLive();
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
  },
};
</script>
<style scoped>
.footer-text.active{
    color: #5C98FF !important;
}
.modal-content {
    border: 2px solid #714DC7;
}
td .fa-trash {
    color: red;
}
.modal-cross {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding-top: 3px;
    margin-left: auto;
    color: white;
    cursor: pointer;
    margin-right: -9px;
    margin-top: -9px;
    background: #714DC7;
}
.banking-icons {
    width: auto;
    height: auto;
    padding: 5px;
    border-radius: 5px;
}
.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 50px;
    width: 50px;
    /* right: 0; */
    left: 5px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}
.nav-item {
    /* margin-left: 10px;
    margin-right: 10px; */
    /* border: 1px solid red; */
    font-size: 1rem;
    cursor: pointer;
    font-weight: 600;
    color: #93A1C0 !important;
    min-width: 60px;
    /* height: 100px; */
}
/* .nav-item:hover,
.nav-item.active {
    border-radius: 5px;
    background: #02133E;
    color: red !important;
} */
/* @media (max-width: 767.98px) { */
    .footer {
        bottom: 0;
        height: 4rem !important;
        border-top: 1px solid #323743;
        width: 100%;
        /* background: white;#F5C0C2 */
        background: #1D1F26;
        /* box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px; */
        /* border-top-left-radius: 5px;
        border-top-right-radius: 5px; */
        /* color: #000000; */
        /* border-top: 2px solid black; */
    }
    .footer-sm {
        position: fixed;
    }
    .footer-lg {
        position: absolute;
    }
    .banking-icons {
        width: auto;
        height: auto;
        padding: 0.2rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        border-radius: 3px;
    }
    .footer {
        padding: 1px !important;
    }
    /* .banking-icons img {
        width: 25px;
        height: 25px;
        border-radius: 3px;
    } */
/* } */
</style>
